// src/Components/Auth/RegisterModal.js
import React, { useState } from 'react';
import { auth, firestore } from '../../firebase';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import Modal from './Modal/Modal';
import RegisterForm from './RegisterForm/RegisterForm';

const RegisterModal = ({ isOpen, onClose }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      // Rol toevoegen in Firestore
      await setDoc(doc(firestore, "users", userCredential.user.uid), {
        email: userCredential.user.email, // Voeg email toe aan Firestore document
        role: 'eindgebruiker' // Standaardrol voor nieuwe gebruikers
      });
      navigate('/'); // Navigeer naar het dashboard na succesvolle registratie
      onClose(); // Sluit de modal
    } catch (error) {
      setError(error.message);
    }
  };
  if (!isOpen) return null;


  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <RegisterForm
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        onRegister={handleSignUp}
        error={error}
      />
    </Modal>
  );
};

export default RegisterModal;
